<template>
  <el-card style="width: 100%">
    <div
      slot="header"
      class="clearfix"
    >
      <span>Áfa kimutatás - központi</span>
    </div>
    <div class="filter-container">
      <el-form
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="20" style="display: flex; ">
            <el-form-item
              label="Dátum"
            >
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                :clearable="false"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="dateRangeOptions"
                style="margin-right: 10px;"
                @change="fetchData"
              />
            </el-form-item>
            <el-form-item style="margin-right: 10px;"
                          label="Beszállító"
            >
              <el-select
                v-model="partner"
                filterable
                remote
                :remote-method="searchPartner"
                :loading="partnerLoading"
                placeholder="Gépelj a kereséshez..."
                style="width: 100%;"
                value-key="id"
                @change="fetchData"
                clearable
              >
                <el-option
                  v-for="p in partners"
                  :key="p.company.id"
                  :value="p"
                  :label="p.company.name"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="Termék"
            >
              <el-select
                v-model="product"
                filterable
                remote
                :remote-method="searchProduct"
                :loading="productLoading"
                placeholder="Gépelj a kereséshez..."
                style="width: 100%;"
                value-key="id"
                @change="fetchData"
                clearable
              >
                <el-option
                  v-for="p in products"
                  :key="p.id"
                  :value="p"
                  :label="p.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div style="text-align: right; margin-top: 24px;">
              <el-button
                :loading="downloadLoading"
                icon="el-icon-download"
                @click="download"
              >
                Letöltés
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div v-loading="loading">
      <el-table
        :key="tableKey"
        :data="vatValues.values"
        style="width: 100%"
        row-key="id"
        border
        :summary-method="getSummaries"
        show-summary
      >
        <!--@sort-change="handleSortChange"-->
        <!--&gt;-->

        <component
          :is="column.value"
          v-for="column in allColumns"
          :key="column.value"
        />
      </el-table>

    </div>
  </el-card>
</template>

<script>
import columns, { allColumns, labels } from './columns';
import moment from 'moment';
import { saveAs } from 'file-saver';


export default {
  components: {
    ...columns,
  },
  data() {
    const start = moment()
      .startOf('year')
      .format('Y-MM-DD');
    const end = moment()
      .format('Y-MM-DD');
    return {
      labels,
      allColumns,
      tableKey: 0,
      itemLoading: 0,
      vatValues: {},
      currentSort: {
        prop: 'gross_price',
        order: 'desc',
      },
      loading: false,
      downloadLoading: false,
      printLoading: false,
      filterConfig: null,
      storageType: ['own'],
      stockDate: moment()
        .add(-1, 'day')
        .format('YYYY-MM-DD'),
      productLoading: false,
      partnerLoading: false,
      product: null,
      products: [],
      partner: null,
      partners: [],
      dateRange: [start, end],
      dateRangeOptions: {
        firstDayOfWeek: 1,
        shortcuts: [{
          text: 'Aktuális hét',
          onClick(picker) {
            const start = moment()
              .weekday(1)
              .toDate();
            const end = moment()
              .weekday(7)
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző hét',
          onClick(picker) {
            const start = moment()
              .subtract({ weeks: 1 })
              .weekday(1)
              .toDate();
            const end = moment()
              .subtract({ weeks: 1 })
              .weekday(7)
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Aktuális hónap',
          onClick(picker) {
            const start = moment()
              .startOf('month')
              .toDate();
            const end = moment()
              .endOf('month')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző hónap',
          onClick(picker) {
            const start = moment()
              .subtract({ months: 1 })
              .startOf('month')
              .toDate();
            const end = moment()
              .subtract({ months: 1 })
              .endOf('month')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző 3 hónap',
          onClick(picker) {
            const start = moment()
              .subtract({ months: 3 })
              .startOf('month')
              .toDate();
            const end = moment()
              .subtract({ months: 1 })
              .endOf('month')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Aktuális év',
          onClick(picker) {
            const start = moment()
              .startOf('year')
              .toDate();
            const end = moment()
              .endOf('year')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző év',
          onClick(picker) {
            const start = moment()
              .subtract({ years: 1 })
              .startOf('year')
              .toDate();
            const end = moment()
              .subtract({ years: 1 })
              .endOf('year')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'YTD',
          onClick(picker) {
            const start = moment()
              .startOf('year')
              .toDate();
            const end = moment()
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'MTD',
          onClick(picker) {
            const start = moment()
              .startOf('month')
              .toDate();
            const end = moment()
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },
  computed: {},
  watch: {},
  async mounted() {
    this.fetchData();
  },
  methods: {
    async download() {
      this.downloadLoading = true;
      try {
        const excel = await axios({
          url: `api/reports/vat/central/download`,
          method: 'POST',
          responseType: 'blob',
          data: {
            from: this.dateRange[0],
            to: this.dateRange[1],
            supplier_id: this.partner && this.partner.id,
            product_id: this.product && this.product.id,
          },
        });
        saveAs(excel, `vatcentral.xlsx`);
      } catch (e) {
        console.log(e)
      }
      this.downloadLoading = false;
    },

    handleSortChange({ column, prop, order }) {
    },

    getSummaries() {
      return this.vatValues.hasOwnProperty('summary') ? [
        'Összeg',
        '',
        this.vatValues.summary.vat + ' Ft',
        this.vatValues.summary.net_price + ' Ft',
        this.vatValues.summary.gross_price + ' Ft',
        this.vatValues.summary.count + ' db',
      ] : [];
    },

    async searchProduct(query) {
      if (query !== '') {
        this.productLoading = true;
        this.products = await this.$store.dispatch('product/search', '?name=' + query);
        this.productLoading = false;
      }
    },

    async searchPartner(query) {
      if (query !== '') {
        this.partnerLoading = true;
        this.partners = await this.$store.dispatch('partner/search', '?name=' + query + '&is_supplier=true');
        this.partnerLoading = false;
      }
    },
    async fetchData() {
      this.loading = true;
      let query = `api/reports/vat/central/${this.dateRange.join(',')}?`;

      if (this.partner) {
        query += `supplier_id=${this.partner.id}&`;
      }

      if (this.product) {
        query += `product_id=${this.product.id}`;
      }

      this.vatValues = await axios.get(query);
      this.loading = false;
    },
  },
};
</script>
<style lang="scss">
  .stockValue-table {
    .el-table__footer {
      td {
        .cell {
          font-weight: 700;
        }
      }
    }
  }
</style>
